import Image from 'next/image'
import { useState } from 'react'

import { basePath } from '@front/runtime-config'

import { useAppRouter } from '../../hooks/useAppRouter'

import { SplashScreenWrapper } from './SplashScreen.style'

export const SplashScreen = (): JSX.Element => {
  const { router } = useAppRouter()
  const [showUrl, setShowUrl] = useState(false)
  return (
    <SplashScreenWrapper>
      <Image
        src={`${basePath}/hublo-logo-horizontal.svg`}
        width={200}
        height={32}
        alt="hublo logo"
        onClick={() => setShowUrl(true)}
      />
      {showUrl && <span>{router?.pathname}</span>}
    </SplashScreenWrapper>
  )
}
